/**
 * מצב ריק — DESIGN.md 4.7, 6.3ב.
 *
 * ⭐ "אייקון 32px + משפט אחד + פעולה." משמש בציבורי (קישור לקטלוג) ובפאנל
 *    (כפתור הוספה) - `action` הוא `ReactNode` חופשי כדי לתמוך בשני המקרים.
 */
import type { ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';

interface EmptyStateProps {
  icon: Icon;
  message: string;
  action?: ReactNode;
}

export function EmptyState({ icon: IconComponent, message, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-4 py-12 text-center">
      <IconComponent size={32} weight="regular" aria-hidden="true" className="text-muted" />
      <p className="text-muted">{message}</p>
      {action}
    </div>
  );
}
